import React, { useState, useEffect, useRef } from 'react';
import newIconRobinhood from '../assets/new-icon-robinhood.jpg';
import pierluigiCopertina1 from '../assets/pierluigi_girolami_copertina1.png';
import emilianoBattanzi from '../assets/emiliano_battazzi_copertina1.png';
import pierluigiCopertina2 from '../assets/pierluigi_girolami_copertina2.png';
import pierluigiCopertina3 from '../assets/pierluigi_girolami_copertina3.png';
import pierluigiCopertina4 from '../assets/pierluigi_girolami_copertina4.png';
import fotoAntonella1 from '../assets/foto_antonella-1.JPG';
import fotoAntonella2 from '../assets/foto_antonella-2.JPG';
import fotoAntonella3 from '../assets/foto_antonella-3.JPG';
import fotoAntonella4 from '../assets/foto_antonella-4.JPG';
import fotoAntonella5 from '../assets/foto_antonella-5.JPG';
import fotoAntonella6 from '../assets/foto_antonella-6.JPG';
import fotoAntonella7 from '../assets/foto_antonella-7.jpg';
import fotoAntonella8 from '../assets/foto_antonella-8.jpg';
import locandinaCorsoVolontariImg from '../assets/locandina_corso_volontari.png';

const ImageCarousel = ({ images, onOpenFullscreen }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="relative">
      <div className="overflow-hidden rounded-lg">
        <div className="flex items-center justify-center">
          <img
            src={images[currentIndex]}
            alt={`Foto ${currentIndex + 1}`}
            className="h-64 object-contain cursor-pointer"
            onClick={() => onOpenFullscreen(currentIndex)}
          />
        </div>
      </div>

      <div className="flex items-center justify-between mt-4">
        <button
          onClick={goToPrev}
          className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary/80 transition duration-300"
          aria-label="Foto precedente"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>

        <div className="text-center">
          <span className="text-gray-600">{currentIndex + 1} / {images.length}</span>
        </div>

        <button
          onClick={goToNext}
          className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary/80 transition duration-300"
          aria-label="Foto successiva"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </button>
      </div>
    </div>
  );
};

const FullscreenImageModal = ({ isOpen, onClose, images, initialIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;

      if (e.key === 'ArrowLeft') {
        goToPrev();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      } else if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-300"
        aria-label="Chiudi"
      >
        <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <button
        onClick={goToPrev}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors duration-300"
        aria-label="Foto precedente"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-10 h-10">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>

      <div className="max-w-5xl max-h-screen p-4">
        <img
          src={images[currentIndex]}
          alt={`Foto ${currentIndex + 1}`}
          className="max-h-[85vh] max-w-full object-contain"
        />
      </div>

      <button
        onClick={goToNext}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors duration-300"
        aria-label="Foto successiva"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-10 h-10">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </button>

      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white">
        <span>{currentIndex + 1} / {images.length}</span>
      </div>
    </div>
  );
};

const Modal = ({ isOpen, onClose, title, children, primaryAction }) => {
  const modalRef = useRef(null);

  // Chiudi il modale quando si clicca fuori
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  // Gestisce il tasto Escape per chiudere il modale
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-0 sm:p-4">
      <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"></div>
      <div
        ref={modalRef}
        className="bg-white rounded-lg shadow-xl mx-auto z-10 transform transition-all ease-in-out duration-300 overflow-hidden"
        style={{ maxHeight: '95vh', width: '80%', maxWidth: '900px' }}
      >
        <div className="px-5 sm:px-6 md:px-8 py-4 border-b flex items-center justify-between">
          <h3 className="text-xl sm:text-2xl font-semibold text-primary">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
            aria-label="Chiudi"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="px-5 sm:px-8 md:px-10 py-8 overflow-y-auto" style={{ maxHeight: 'calc(95vh - 140px)', overflowX: 'hidden' }}>
          {children}
        </div>
        <div className="px-5 sm:px-8 md:px-10 py-4 border-t bg-gray-50 flex justify-end">
          {primaryAction}
        </div>
      </div>
    </div>
  );
};

const ImpactStory = ({ image, title, description, fullText, imageObjectPosition = "object-center", imageStyle, isYogaProject = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const [fullscreenInitialIndex, setFullscreenInitialIndex] = useState(0);

  const handleOpenFullscreen = (index) => {
    setFullscreenInitialIndex(index);
    setIsFullscreenOpen(true);
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <img src={image} alt={title} className={`w-full h-48 object-cover ${imageObjectPosition}`} style={imageStyle} />
        <div className="p-4">
          <h3 className="text-xl font-bold text-primary mb-2">{title}</h3>
          <p className="text-gray-700 mb-4">{description}</p>
          {fullText && (
            <div className="flex justify-end">
              <button
                onClick={() => setIsModalOpen(true)}
                className={`${isYogaProject ? 'bg-accent hover:bg-accent/90' : 'bg-primary hover:bg-primary/90'} text-white py-2 px-4 rounded-lg text-sm font-semibold transition duration-300`}
              >
                {isYogaProject ? 'Scopri di più' : 'Leggi tutto'}
              </button>
            </div>
          )}
        </div>
      </div>

      {fullText && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={title}
          primaryAction={
            <button
              onClick={() => setIsModalOpen(false)}
              className="bg-primary text-white py-2 px-4 rounded-lg font-semibold hover:bg-primary/90 transition duration-300"
            >
              Chiudi
            </button>
          }
        >
          <div className="prose max-w-none">
            {fullText.split('\n\n').map((paragraph, index) => {
              const isBlock = /^\s*<(ul|ol|div|h[1-6]|blockquote)/i.test(paragraph);
              return isBlock ? (
                <div
                  key={index}
                  className="mb-6 text-base md:text-lg text-gray-700"
                  style={{ lineHeight: '1.8' }}
                  dangerouslySetInnerHTML={{ __html: paragraph }}
                />
              ) : (
                <p
                  key={index}
                  className="mb-6 text-base md:text-lg text-gray-700"
                  style={{ lineHeight: '1.8' }}
                  dangerouslySetInnerHTML={{ __html: paragraph }}
                />
              );
            })}

            {title === "La storia di Pierluigi" && (
              <div className="mt-10 border-t pt-8">
                <h4 className="text-xl font-semibold text-primary mb-4">I libri di Pierluigi</h4>
                <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                  <div className="book-cover">
                    <img
                      src={pierluigiCopertina1}
                      alt="Libro di Pierluigi Girolami"
                      className="h-48 object-cover rounded-md shadow-md hover:shadow-lg transition-shadow duration-300"
                    />
                  </div>
                  <div className="book-cover">
                    <img
                      src={pierluigiCopertina2}
                      alt="Libro di Pierluigi Girolami"
                      className="h-48 object-cover rounded-md shadow-md hover:shadow-lg transition-shadow duration-300"
                    />
                  </div>
                  <div className="book-cover">
                    <img
                      src={pierluigiCopertina3}
                      alt="Libro di Pierluigi Girolami"
                      className="h-48 object-cover rounded-md shadow-md hover:shadow-lg transition-shadow duration-300"
                    />
                  </div>
                </div>
              </div>
            )}

            {title === "La storia di Antonella" && (
              <div className="mt-10 border-t pt-8">
                <h4 className="text-xl font-semibold text-primary mb-4">Le foto di Antonella</h4>
                <p className="text-gray-700 mb-6">La fotografia è la mia passione, un modo per catturare e condividere la bellezza del mondo. Ecco alcune delle mie foto. Clicca su un'immagine per ingrandirla.</p>
                <ImageCarousel
                  images={[
                    fotoAntonella1,
                    fotoAntonella2,
                    fotoAntonella3,
                    fotoAntonella4,
                    fotoAntonella5,
                    fotoAntonella6,
                    fotoAntonella7,
                    fotoAntonella8
                  ]}
                  onOpenFullscreen={handleOpenFullscreen}
                />
              </div>
            )}
            {title === "La storia di Emiliano" && (
              <div className="mt-10 border-t pt-8">
                <h4 className="text-xl font-semibold text-primary mb-4">Il libro di Emiliano</h4>
                <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                  <div className="book-cover">
                    <img
                      src={emilianoBattanzi}
                      alt="Libro di Pierluigi Girolami"
                      className="h-48 object-cover rounded-md shadow-md hover:shadow-lg transition-shadow duration-300"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}

      {/* Fullscreen Image Modal */}
      {title === "La storia di Antonella" && fullText && (
        <FullscreenImageModal
          isOpen={isFullscreenOpen}
          onClose={() => setIsFullscreenOpen(false)}
          images={[
            fotoAntonella1,
            fotoAntonella2,
            fotoAntonella3,
            fotoAntonella4,
            fotoAntonella5,
            fotoAntonella6,
            fotoAntonella7,
            fotoAntonella8
          ]}
          initialIndex={fullscreenInitialIndex}
        />
      )}
    </>
  );
};
const StorieIniziative = () => {
  const [isCorsoModalOpen, setIsCorsoModalOpen] = useState(false);
  const corsoVolontariEvent = {
    title: "Essere Volontarie e Volontari in EMATOLOGIA",
    date: "25 ottobre 2025",
    time: "09:00 - 12:30",
    location: "Ematologia - Via Benevento 27/A, Roma (IV piano sala riunioni)",
    description: "Un corso per offrire strumenti concreti e uno spazio di riflessione a chi vuole essere volontario: per imparare a essere utili con competenza, empatia e rispetto.",
    color: "bg-cyan-700",
    category: "Corso di Formazione",
    //flyerImage: locandinaCorsoVolontariImg,
    programLink: locandinaCorsoVolontariImg,
    downloadFileName: "Locandina_Corso_Formazione_Volontari_25_ottobre_2025.png"
  };

  return (
    <>
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary/80 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Progetti e Iniziative</h1>
          <p className="text-xl text-center max-w-3xl mx-auto">
            Conosci i nostri progetti e iniziative, per costruire insieme un percorso di cura più accessabile, umano e
            condiviso. <br />
            Il tuo contributo può renderli possibili!          </p>
        </div>
      </div>

      {/* Iniziative */}
      <section className="py-16 px-4">
        <div className="container mx-auto">
          <h1 className="text-4xl font-bold text-center mb-12 text-red-600">
            I Nostri Progetti
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <ImpactStory
              image={newIconRobinhood}
              title="Progetto ADAMTS13 per i pazienti con PTT"
              description="Un'iniziativa dedicata ai pazienti affetti da Porpora Trombotica Trombocitopenica."
              fullText={`<strong style="color: #dc2626; display: block; text-align: center;">PROGETTO ADAMTS13: UN AIUTO CONCRETO AI PAZIENTI CON LA PTT<br/>(PORPORA TROMBOTICA TROMBOCITOPENICA)</strong><br/><span style="display: block; text-align: center;">Dott.ssa Silvia Trisolini</span>

<em style="color: #dc2626; font-weight: 600;">Conosci la malattia</em>

La porpora trombotica trombocitopenica (PTT), meglio conosciuta come Sindrome di Moschowitz, è una rara malattia che colpisce prevalentemente giovani e bambini ed è gravata da una elevata mortalità se non prontamente trattata. Nella maggior parte dei casi è una patologia autoimmune per cui vengono prodotti degli autoanticorpi contro l'enzima ADAMTS13.

Alla base della patologia, vi è <span style="color: #dc2626;">una deficiente attività dell'enzima ADAMTS13</span> una metalloproteasi che ha lo scopo di tagliare i multimeri ultra-large del fattore di von Willebrand, esposti in seguito ad un danno endoteliale dovuto a cause infettive, farmaci, traumi, interventi chirurgici. Ciò <span style="color: #dc2626;">determina una iper-aggregazione piastrinica</span> con conseguente formazione di trombi nella microcircolazione e <span style="color: #dc2626;">danni ischemici tissutali</span> a livello di tutti gli organi soprattutto <span style="color: #dc2626;">cuore, cervello e intestino</span>. Per questo la malattia è gravata da un elevato rischio di mortalità e morbidità.

Vi è una <span style="color: #dc2626;">forma autoimmune (iTTP) acquisita</span> in cui vi è la produzione di autoanticorpi che inibiscono l'attività dell'ADAMTS13 la iTTP è la forma più frequente e comune soprattutto nei giovani adulti. Vi è una <span style="color: #dc2626;">forma</span> più rara quella <span style="color: #dc2626;">congenita (cTTP)</span> più frequente nei bambini, alla base della quale vi è una o più mutazioni genetiche ereditarie che coinvolgono il gene che codifica per l'ADAMTS13, per cui la metalloproteasi non è prodotta oppure è deficiente.

La <span style="color: #dc2626;">diagnosi</span> della malattia viene sospettata su base clinica, quando presente anemia emolitica microangiopatica e piastrinopenia, ma viene poi <span style="color: #dc2626;">confermata attraverso il dosaggio dell'attività dell'ADAMTS13 che deve essere &lt;10% e la ricerca degli autoanticorpi</span>.

La terapia cardine della PTT autoimmune è la plasma-exchenge (PEX) che ha lo scopo di rimuovere gli anticorpi circolanti e rifornire di ADAMTS13 attraverso lo scambio con plasma fresco congelato, la terapia steroidea come immunosoppressore e il Caplacizumab nano anticorpo che ha la capacità di impedire l'aggregazione piastrinica al fattore di von Willebrand ed impedisce le ischemie tissutali dovute alla formazione dei trombi nella microcircolazione, riducendo così la mortalità. Mentre per la forma congenita la terapia cardine è l'infusione di plasma fresco congelato, a breve sarà disponibile in commercio l'ADAMTS13 ricombinante come terapia sostitutiva.

Il <span style="color: #dc2626;">trattamento tempestivo</span> sia della forma acquisita che di quella congenita riduce drasticamente la mortalità e morbidità della malattia.

E' pertanto fondamentale avere a disposizione il <span style="color: #dc2626;">dosaggio dell'attività</span> dell'ADAMTS13 per confermare o meno la diagnosi e per ridurre i costi nel caso di una diagnosi alternativa.

Dopo la risposta al trattamento è importante il monitoraggio dell'attività dell'ADAMTS13 come da indicazione delle recenti linee guida, soprattutto nella forma acquisita autoimmune.

Infatti, una riduzione dell'attività &lt;10% dell'enzima espone il paziente ad un elevato rischio di ricaduta della malattia. In questi casi è importante fare una terapia immunosoppressiva per prevenire la recidiva.

<em style="color: #dc2626; font-weight: 600;">Conosci il progetto</em>

La Ematologia, centro di riferimento regionale per questa patologia, <span style="color: #dc2626;">non è possibile eseguire il test per l'attività dell'ADAMTS13</span> e la ricerca di autoanticorpi negli 81 pazienti seguiti, pur avendo a disposizione la strumentazione e l'expertise tecnica, <span style="color: #dc2626;">per la mancanza di reagenti</span>. Questo è dovuto al fatto che tali test, pur essendo previsti dalle guida per la gestione della malattia, non sono stati ancora inseriti nei LEA e quindi non sono attualmente rimborsabili, ma si possono eseguire solo con fondi privati, con l'impossibilità di avere i risultati in tempo reale.

Nel laboratorio di coagulazione dell'Ematologia è già presente uno strumento con il quale, utilizzando reagenti specifici, è possibile eseguire il test dell'attività dell'ADAMTS13 e la ricerca degli anticorpi.

Avendo pertanto in laboratorio già presente l'apparecchiatura e l'expertise tecnica per eseguire le analisi e per la refertazione dei risultati, l'Associazione Robin Hood Roma ODV si è impegnata per l'acquisto dei reagenti specifici per eseguire attività e ricerca anticorpi anti ADAMTS13.

Di seguito si presenta una stima dell'impegno economico annuo dell'associazione, basata sull'attuale numero di 81 pazienti:

<ul style="list-style-type: disc; padding-left: 1.5rem;">
<li style="margin-bottom: 0.5rem;">Per il dosaggio dell'enzima, sono necessari 10 kits all'anno (ogni kit da 25 test costa 5.000 euro=50.000 euro)</li>
<li style="margin-bottom: 0.5rem;">Per il dosaggio degli anticorpi, servono 2 kits all'anno (ogni kit da 96 test costa 835 Euro = 1.670 Euro).</li>
</ul>

Nonostante l'impegno economico significativo (oltre 50.000 euro annui), l'Associazione Robin Hood Roma ODV ritiene il progetto di estrema importanza, perché permette un'adeguata e tempestiva assistenza a tutti i bambini e agli adulti affetti da questa rara malattia.`}
              imageStyle={{ objectFit: 'contain', backgroundColor: 'white', padding: '2rem', height: '15rem' }}
              isYogaProject={true}
            />
            <ImpactStory
              image={newIconRobinhood}
              title="Progetto Yoga per i pazienti ricoverati in Ematologia"
              description="Un progetto innovativo che porta i benefici dello yoga direttamente nei reparti di ematologia."
              fullText={`Il <strong>17 novembre 2025</strong> ha preso il via in Ematologia dell'AOU Policlinico Umberto I di Roma il <strong>Progetto Yoga</strong> per i pazienti, promosso e sostenuto dall'Associazione <strong>Robin Hood Roma ODV</strong>. Si tratta di un'iniziativa unica in Italia per pazienti adulti ricoverati in Ematologia, sottoposti a chemioterapia e/o ad autotrapianto di cellule staminali. L'iniziativa nasce dal desiderio di portare <strong>sollievo, serenità</strong> e <strong>ascolto</strong> a chi affronta momenti di grande difficoltà.

Ogni giorno, dal lunedì al venerdì, un gruppo di <strong>6 volontarie yogi</strong>, formate nella tradizione di T.K.V. Desikachar e coordinate da Mario Cistulli, entra nelle stanze di degenza per incontrare i pazienti, spesso provati dalla malattia e dai trattamenti. Con gesti delicati e parole di attenzione, accompagnano ogni persona in un percorso di <strong>ritrovata armonia con il proprio corpo</strong>, aiutandola a sentire meno dolore, ridurre lo stress e ritrovare fiducia.

Le pratiche comprendono movimenti dolci (<strong>āsana</strong>) che favoriscono benessere e leggerezza, esercizi di respirazione (<strong>prānāyāma</strong>) che portano calma e rilassamento, momenti di rilassamento profondo per sciogliere tensioni, e <strong>meditazioni di consapevolezza</strong> che aiutano a ritrovare equilibrio e serenità interiore. Ogni proposta è adattata alle esigenze individuali e può essere praticata anche autonomamente, grazie a sequenze personalizzate lasciate ai pazienti.

Ogni incontro è un piccolo gesto di vicinanza, una possibilità di sentirsi accolti e supportati, un momento in cui la malattia cede spazio a <strong>respiro, ascolto e attenzione</strong>. Il progetto è realizzato in collaborazione con l'équipe sanitaria, con riunioni di supervisione per garantire sicurezza e qualità.`}
              imageStyle={{ objectFit: 'contain', backgroundColor: 'white', padding: '2rem', height: '15rem' }}
              isYogaProject={true}
            />
            <ImpactStory
              image={newIconRobinhood}
              title="Supporto per le famiglie ed i pazienti sottoposti a terapie innovative"
              description="Scopri di più sulle CAR-T e il nostro programma di supporto per pazienti e famiglie."
              fullText={`<strong style="color: #dc2626;">PROGETTO DI SUPPORTO PER LE FAMIGLIE E I PAZIENTI SOTTOPOSTI A TERAPIA CON CAR-T E A TRAPIANTO DI CELLULE STAMINALI</strong><br/>Marta Montanari, coordinatrice infermieristica, e Marta Pierfederici, infermiera.

Siamo due operatrici che lavorano presso il reparto di Terapie Innovative della U.O.C. dell'Ematologia del Policlinico Umberto I, impegnate nella cura e nel supporto dei pazienti sottoposti a trattamenti avanzati. Attualmente stiamo frequentando il Master di I livello “CAR-T Therapy e Trapianto di CSE: gestione delle prevenzioni e complicanze”, con il supporto finanziario dell'Associazione Robin Hood Roma ODV. Per l'elaborato finale del Master, il nostro progetto prevede la realizzazione di un vademecum informativo, destinato a tutti i pazienti ricoverati nel nostro reparto: trapiantati, candidati alla terapia CAR-T, protocolli di chemioterapia, anticorpi monoclonali o bispecifici. <span style="color: #dc2626;">La brochure raccoglierà in un unico strumento tutte le informazioni necessarie: spiegazioni semplici e chiare sulle terapie, il percorso di ricovero, le principali precauzioni e le risposte alle domande più frequenti.</span>

La motivazione e l'importanza della brochure risiedono nella necessità di fornire ai pazienti uno strumento chiaro e accessibile, che riduca ansia e incertezza, favorisca la comprensione del percorso terapeutico e supporti l'aderenza alle indicazioni cliniche. Sarà utile sia al momento della presa in carico sia alla dimissione, permettendo di avere sempre a portata di mano informazioni affidabili e comprensibili.

Il sostegno dell'Associazione Robin Hood ci permetterà di produrre e stampare brochure informative che offriranno ai pazienti indicazioni chiare e utili, contribuendo così a migliorare in modo tangibile la loro esperienza, la sicurezza e il benessere nel reparto.`}
              imageStyle={{ objectFit: 'contain', backgroundColor: 'white', padding: '2rem', height: '15rem' }}
              isYogaProject={true}
            />
          </div>
        </div>
      </section>
      {/* le nostre iniziative */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="container mx-auto">
          <h1 className="text-4xl font-bold text-center mb-12 text-red-600">
            Le Nostre Iniziative
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            <div
              className="bg-white rounded-lg shadow-md overflow-hidden border border-primary/10 hover:shadow-lg transition-all duration-300 transform hover:scale-102 flex flex-col"
            >
              <div className={`${corsoVolontariEvent.color} text-white p-4`}>
                {corsoVolontariEvent.category && (
                  <span className="text-xs font-semibold bg-white/20 text-white px-2 py-1 rounded-full mb-2 inline-block">{corsoVolontariEvent.category}</span>
                )}
                <h3 className="text-xl font-bold">{corsoVolontariEvent.title}</h3>
                <p className="text-sm mt-2 opacity-90 flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  {corsoVolontariEvent.date}
                </p>
                {corsoVolontariEvent.time && corsoVolontariEvent.time.trim().toUpperCase() !== "DA DEFINIRE" && corsoVolontariEvent.time.trim() !== "" && (
                  <p className="text-sm mt-1 opacity-90 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {corsoVolontariEvent.time}
                  </p>
                )}
                <p className="text-sm mt-1 opacity-90 flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  {corsoVolontariEvent.location}
                </p>
              </div>
              <div className="p-4 flex flex-row gap-4 items-start flex-grow min-h-[180px]">
                <div className="flex-grow flex flex-col min-h-full">
                  <p className="text-sm text-gray-700 mb-4 flex-grow">{corsoVolontariEvent.description}</p>
                  <div className="flex gap-3 justify-start flex-wrap">
                    <button
                      className="inline-flex items-center px-4 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-300"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsCorsoModalOpen(true);
                      }}
                    >
                      Leggi tutto
                      <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>
                    {corsoVolontariEvent.programLink && (
                      <a
                        href={corsoVolontariEvent.programLink}
                        download={corsoVolontariEvent.downloadFileName || "Programma_Evento.pdf"}
                        className="inline-flex items-center px-4 py-2 bg-accent text-white text-sm font-medium rounded-md hover:bg-accent/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent transition-colors duration-300"
                        aria-label={`Scarica ${corsoVolontariEvent.downloadFileName ? 'la locandina' : 'il programma'} per ${corsoVolontariEvent.title}`}
                      >
                        {corsoVolontariEvent.downloadFileName ? 'Scarica Locandina' : 'Scarica Programma'}
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                      </a>
                    )}
                  </div>
                </div>
                {corsoVolontariEvent.flyerImage && (
                  <div className="w-1/3 flex-shrink-0 self-center">
                    <img
                      src={corsoVolontariEvent.flyerImage}
                      alt={`Locandina ${corsoVolontariEvent.title}`}
                      className="w-full h-auto object-contain rounded-md shadow-sm"
                      style={{ maxHeight: '130px' }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modale Corso di Formazione */}
      {isCorsoModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 p-4 md:p-6"
          onClick={(e) => e.target === e.currentTarget && setIsCorsoModalOpen(false)}
          role="dialog"
          aria-modal="true"
        >
          <div
            className="bg-white rounded-xl shadow-2xl w-full max-w-5xl mx-4 border border-gray-200 flex flex-col max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className={`${corsoVolontariEvent.color} px-6 py-5 text-white relative sticky top-0 z-10`}>
              <button
                onClick={() => setIsCorsoModalOpen(false)}
                className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                aria-label="Chiudi modal"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              <h3 className="text-2xl font-bold">{corsoVolontariEvent.title}</h3>
              <div className="flex items-center mt-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <p className="text-sm opacity-90">{corsoVolontariEvent.date}</p>
              </div>
              {corsoVolontariEvent.time && (
                <div className="flex items-center mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-sm opacity-90">{corsoVolontariEvent.time}</p>
                </div>
              )}
              <div className="flex items-center mt-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <p className="text-sm opacity-90">{corsoVolontariEvent.location}</p>
              </div>
            </div>
            <div className="p-6 pb-16 overflow-y-auto flex-grow">
              {corsoVolontariEvent.flyerImage && (
                <div className="mb-6">
                  <img
                    src={corsoVolontariEvent.flyerImage}
                    alt={`Locandina ${corsoVolontariEvent.title}`}
                    className="w-full max-w-lg mx-auto rounded-lg shadow-lg object-contain"
                    style={{ maxHeight: '50vh' }}
                  />
                </div>
              )}
              <div className="text-left space-y-6">
                <div className="text-center mb-8">
                  <p className="text-gray-500 font-medium">25 ottobre 2025</p>
                  <h3 className="text-2xl text-primary font-semibold italic mt-2">Corso di formazione per volontarie e volontari</h3>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mt-2 uppercase">ESSERE VOLONTARIE e VOLONTARI in EMATOLOGIA</h2>
                </div>

                <p className="text-gray-700 leading-relaxed">
                  <strong>Il 25 ottobre 2025 si è tenuto il primo corso di formazione per volontarie e volontari in Ematologia</strong>, un percorso pensato per preparare chi desidera offrire il proprio tempo ai pazienti e alle loro famiglie, all'interno della UOC di Ematologia dell'AOU Policlinico Umberto I, diretta dal <strong>Prof. Maurizio Martelli</strong>.
                </p>

                <p className="text-gray-700 leading-relaxed">
                  Il corso è nato dalla necessità di fornire ai volontari strumenti concreti e competenze relazionali adeguate a un reparto complesso come quello ematologico, dove ogni giorno si affrontano malattie come leucemie, linfomi, mieloma e altre malattie rare e si gestiscono percorsi di cura intensivi, come la chemioterapia e il trapianto di cellule staminali.
                </p>

                <blockquote className="border-l-4 border-accent pl-4 italic text-gray-700 my-6 bg-gray-50 p-4 rounded-r-lg">
                  “Essere volontari non significa solo “dare una mano”. Significa esserci davvero: ascoltare, accogliere, camminare accanto a chi sta affrontando un momento difficile. Il volontariato è fatto di tempo, ascolto e presenza. Ma anche di preparazione, cura e rispetto. Per questo nasce il nostro corso di formazione, un percorso che unisce conoscenze mediche essenziali e attenzione alla dimensione umana.”
                  <footer className="text-sm font-semibold text-gray-600 mt-2 not-italic">— ha esordito la Presidente, dott.ssa Fiorina Giona, presentando il corso.</footer>
                </blockquote>

                <p className="text-gray-700 leading-relaxed">
                  Durante l'incontro si sono approfondite le aree tematiche fondamentali per poter iniziare il percorso di volontariato:
                </p>

                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-bold text-gray-800 mb-2">1. Conoscere il reparto e i propri compiti: un reparto complesso, un ruolo prezioso</h4>
                    <p className="text-gray-700 leading-relaxed">
                      I volontari sono stati edotti sulla struttura e sulle modalità organizzative dell'Ematologia, sottolineandone la caratteristica di luogo dove ogni giorno si intrecciano cura, ricerca e speranza. Sono stati, inoltre, informati sulle norme che regolano la loro attività: obbligo del tesserino, registrazione delle presenze, rispetto del segreto professionale e osservanza del codice deontologico.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-bold text-gray-800 mb-2">2. Conoscere le principali patologie ematologiche: capire le malattie per capire le persone</h4>
                    <p className="text-gray-700 leading-relaxed">
                      Grazie alla guida della Dott.ssa Anna Maria Testi, i partecipanti hanno ricevuto informazioni semplici ed essenziali sulle principali malattie del sangue—leucemie, linfomi, mieloma—e i percorsi di cura più frequenti, come la chemioterapia o il trapianto di cellule staminali, utili per comprendere meglio il contesto clinico e il vissuto dei pazienti. Non per diventare esperti, ma per saper stare accanto con maggiore consapevolezza.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-bold text-gray-800 mb-2">3. Imparare a comunicare con empatia: La forza delle relazioni</h4>
                    <p className="text-gray-700 leading-relaxed">
                      Una parte fondamentale della formazione è stata dedicata alla comunicazione. La Dott.ssa Silvia Finocchi ha affrontato il tema della comunicazione consapevole in reparto: dall'ascolto attivo alla gestione del silenzio, dalla sensibilità emotiva al ruolo cruciale della comunicazione non verbale. Ogni gesto, ogni parola—perfino il silenzio—ha un significato. Il volontario impara, così, a guardare la persona oltre la malattia, a rispettare i tempi, le emozioni e i silenzi. A essere una presenza calma, empatica, capace di creare un piccolo spazio di serenità.
                    </p>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200">
                  <h4 className="text-lg font-bold text-gray-800 mb-2">Un primo passo, insieme</h4>
                  <p className="text-gray-700 leading-relaxed">
                    Questo corso è l'inizio di un cammino: un modo per prepararsi, per crescere e per donare il proprio tempo nel modo più rispettoso e umano possibile. Perché il volontariato, in fondo, è una relazione. Ed è lì che fa la differenza.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-3 flex justify-end gap-3 shadow-lg border-t border-gray-200 sticky bottom-0 z-10 bg-white">
              {corsoVolontariEvent.programLink && (
                <a
                  href={corsoVolontariEvent.programLink}
                  download={corsoVolontariEvent.downloadFileName || "Programma_Evento.pdf"}
                  className="inline-flex items-center px-5 py-2 bg-accent text-white rounded-md hover:bg-accent/90 transition-colors focus:outline-none focus:ring-2 focus:ring-accent shadow-sm"
                  aria-label={`Scarica ${corsoVolontariEvent.downloadFileName ? 'la locandina' : 'il programma'} per ${corsoVolontariEvent.title}`}
                >
                  {corsoVolontariEvent.downloadFileName ? 'Scarica Locandina' : 'Scarica Programma'}
                  <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </a>
              )}
              <button
                onClick={() => setIsCorsoModalOpen(false)}
                className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                aria-label="Chiudi modal"
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Storie di Impatto - NUOVA POSIZIONE 3 */}
    </>
  );
};

export default StorieIniziative;

